'use client'

import { BuilderBlocks } from '@builder.io/react'
import { useState } from 'react'

import { Dropdown } from '@src/components/Dropdown/Dropdown'
import { getBuilderPreviewMode } from '@src/utils/builder.util'

import type { ContentSwitcherProps } from './ContentSwitcher.props'

export const ContentSwitcher = (props: ContentSwitcherProps) => {
  const { items = [], builderBlock, defaultIndex = 0, previewMode = false } = props
  const [selectedIndex, setSelectedIndex] = useState(defaultIndex)
  const isPreviewing = getBuilderPreviewMode().edit && previewMode

  const renderContent = () => {
    return (
      <div>
        <div className="flex flex-col justify-between lg:flex-row lg:gap-8">
          <BuilderBlocks
            parentElementId={builderBlock?.id}
            blocks={items[selectedIndex]?.contentTop}
            dataPath={`component.options.items.${selectedIndex}.contentTop`}
          />
          <div className="w-full shrink-0 lg:w-[240px]">
            <Dropdown
              items={items.map((item) => ({
                id: item.title ?? '',
                displayName: item.title ?? '',
                name: item.title ?? '',
              }))}
              selectedId={items[selectedIndex].title ?? ''}
              onItemIdSelected={(id) =>
                setSelectedIndex(items.findIndex((item) => item.title === id))
              }
            />
          </div>
        </div>
        <BuilderBlocks
          parentElementId={builderBlock?.id}
          blocks={items[selectedIndex]?.contentBottom}
          dataPath={`component.options.items.${selectedIndex}.contentBottom`}
        />
      </div>
    )
  }

  const renderPreviewContent = () => {
    return (
      <div className="flex flex-col gap-8">
        {items.map((item, index) => (
          <div key={item.title} className="flex flex-col gap-4">
            <div className="border-b border-bodi-gray-butters pb-2 font-mono text-body-lg font-bold text-blue-500">
              Previewing item: {item.title}
            </div>
            <BuilderBlocks
              parentElementId={builderBlock?.id}
              blocks={item?.contentTop}
              dataPath={`component.options.items.${index}.contentTop`}
            />
            <BuilderBlocks
              parentElementId={builderBlock?.id}
              blocks={item?.contentBottom}
              dataPath={`component.options.items.${index}.contentBottom`}
            />
          </div>
        ))}
      </div>
    )
  }

  return <>{isPreviewing ? renderPreviewContent() : renderContent()}</>
}
